// src/components/user/controltower/TowerSidebar.jsx
import React from 'react';
import { Search, Package, Zap, X } from 'lucide-react';
import { RegularDeliveryCard } from './RegularDeliveryCard';
import { ExpressDeliveryCard } from './ExpressDeliveryCard';

export function TowerSidebar({
  showList, activeTab, setActiveTab,
  searchQuery, onSearchChange,
  filteredRegular, filteredExpress,
  totalRegular, totalExpress,
  selectedDelivery, onDeliveryClick,
}) {
  return (
    <div className={`
      ${showList ? 'flex' : 'hidden lg:flex'}
      flex-col w-full lg:w-96 bg-white border-r border-slate-200 z-20
      absolute lg:relative top-0 left-0 right-0 bottom-0 lg:inset-auto
    `}>

      {/* Tab selector */}
      <div className="flex border-b border-slate-200">
        <button
          onClick={() => { setActiveTab('regular'); onSearchChange(''); }}
          className={`flex-1 flex items-center justify-center gap-2 py-3 text-sm font-semibold font-montserrat border-b-2 transition-colors ${
            activeTab === 'regular'
              ? 'border-brand-primary text-brand-primary'
              : 'border-transparent text-slate-500 hover:text-slate-700'
          }`}
        >
          <Package className="w-4 h-4" />
          Regular
          <span className={`text-xs px-1.5 py-0.5 rounded-full font-montserrat ${
            activeTab === 'regular' ? 'bg-brand-primary/10 text-brand-primary' : 'bg-slate-100 text-slate-500'
          }`}>
            {totalRegular}
          </span>
        </button>

        <button
          onClick={() => { setActiveTab('express'); onSearchChange(''); }}
          className={`flex-1 flex items-center justify-center gap-2 py-3 text-sm font-semibold font-montserrat border-b-2 transition-colors ${
            activeTab === 'express'
              ? 'border-brand-green text-brand-green'
              : 'border-transparent text-slate-500 hover:text-slate-700'
          }`}
        >
          <Zap className="w-4 h-4" />
          Express
          <span className={`text-xs px-1.5 py-0.5 rounded-full font-montserrat ${
            activeTab === 'express' ? 'bg-brand-green/10 text-brand-green' : 'bg-slate-100 text-slate-500'
          }`}>
            {totalExpress}
          </span>
        </button>
      </div>

      {/* Search */}
      <div className="p-3 border-b border-slate-200">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <input
            type="text"
            placeholder={activeTab === 'express' ? 'Buscar por nombre, dirección...' : 'Buscar por nombre, teléfono, ID...'}
            value={searchQuery}
            onChange={e => onSearchChange(e.target.value)}
            className="w-full pl-9 pr-8 py-2 border border-slate-200 rounded-xl text-sm font-montserrat focus:outline-none focus:ring-2 focus:ring-brand-primary/20 focus:border-brand-primary"
          />
          {searchQuery && (
            <button onClick={() => onSearchChange('')} className="absolute right-2 top-1/2 -translate-y-1/2">
              <X className="w-4 h-4 text-slate-400" />
            </button>
          )}
        </div>
      </div>

      {/* Count */}
      <div className="px-4 py-2 bg-slate-50 border-b border-slate-100">
        <p className="text-xs font-semibold text-slate-500 font-montserrat">
          {activeTab === 'regular'
            ? `${filteredRegular.length} entrega${filteredRegular.length !== 1 ? 's' : ''}`
            : `${filteredExpress.length} express`
          }
        </p>
      </div>

      {/* List */}
      <div className="flex-1 overflow-y-auto divide-y divide-slate-100">
        {activeTab === 'regular' && (
          filteredRegular.length === 0 ? (
            <EmptyState icon={<Package className="w-12 h-12 text-slate-300" />} message={searchQuery ? 'Sin resultados' : 'No hay entregas regulares'} />
          ) : (
            filteredRegular.map(d => (
              <RegularDeliveryCard
                key={d.id}
                delivery={d}
                isSelected={selectedDelivery?.type === 'regular' && selectedDelivery?.data?.id === d.id}
                onClick={() => onDeliveryClick({ type: 'regular', data: d })}
              />
            ))
          )
        )}

        {activeTab === 'express' && (
          filteredExpress.length === 0 ? (
            <EmptyState icon={<Zap className="w-12 h-12 text-slate-300" />} message={searchQuery ? 'Sin resultados' : 'No hay entregas express'} />
          ) : (
            filteredExpress.map(d => (
              <ExpressDeliveryCard
                key={d.id}
                delivery={d}
                isSelected={selectedDelivery?.type === 'express' && selectedDelivery?.data?.id === d.id}
                onClick={() => onDeliveryClick({ type: 'express', data: d })}
              />
            ))
          )
        )}
      </div>
    </div>
  );
}

function EmptyState({ icon, message }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      {icon}
      <p className="mt-3 text-sm text-slate-500 font-montserrat">{message}</p>
    </div>
  );
}